import { Divider } from '@mui/material'
import useExportingJobs from '../useJobs/useExportingJobs'
import JobsTabsItem from './JobsTabsItem'
import JobExportingItem from '../JobItem/JobProcessingItem/JobExportingItem'
import { useExportJobs } from 'features/jobs/models/exportsModel'
import ExportTaskItem from '../JobItem/export/ExportTaskItem'
import { clearLayerExportJobs, getSortedJobs, isPendingOrRunning } from 'features/jobs/models/jobs'
import { useAppStore } from 'app/state/hooks'
import { useMemo } from 'react'
import {
  isDatasetExportingJob,
  isActivityDataExportJob,
  isLayerExportJob,
  isWorkflowDataExportJob
} from 'features/jobs/types'

function JobsExportingTab() {
  const store = useAppStore()
  const { exportingJobsNotCleared, clearJobs: clearOldJobs } = useExportingJobs()
  const exportJobs = useExportJobs()

  const sortedJobs = useMemo(
    () => getSortedJobs([...exportingJobsNotCleared, ...exportJobs]),
    [exportingJobsNotCleared, exportJobs]
  )

  const hasJobs = sortedJobs.length > 0
  const areAllExportingJobsRunning = sortedJobs.every(isPendingOrRunning)
  const areAnyExportingJobsRunning = sortedJobs.some(isPendingOrRunning)

  const handleClear = () => {
    clearLayerExportJobs(store)
    clearOldJobs()
  }

  return (
    <JobsTabsItem
      hasJobs={hasJobs}
      areJobsRunning={areAnyExportingJobsRunning}
      areAllJobsRunning={areAllExportingJobsRunning}
      clearJobs={handleClear}
    >
      <>
        {sortedJobs.map((job, i) => (
          <div key={i}>
            {isDatasetExportingJob(job) && <JobExportingItem job={job} />}
            {(isLayerExportJob(job) || isActivityDataExportJob(job) || isWorkflowDataExportJob(job)) && (
              <ExportTaskItem job={job} />
            )}
            {i !== sortedJobs.length - 1 && <Divider />}
          </div>
        ))}
      </>
    </JobsTabsItem>
  )
}

export default JobsExportingTab
